import { DepartamentoResumido } from "../administracao/departamento-resumido";
import { ModelSagresDatatable } from "../model-sagres-datatable";

export class Aviso extends ModelSagresDatatable {
  Id?: number;
  UsuarioCadastro?: string;
  UsuarioLiberacao?: string;
  DataCadastro?: Date;
  Titulo?: string;
  DataValidade?: Date;
  DataUltAlteracao?: Date;
  PermiteResposta?: boolean;
  Mensagem?: string;
  Protocolo?: string;
  IdDepartamento?: number;
  idDestinatario?: number;

  Departamento?: DepartamentoResumido;

  //objetos que vêm da api
  Arquivos: any[];
  Ativo: number;
  Destinatarios: any[];
  DtLiberacao: Date;
  IdArquivo: number;
  IdSistemaOrigem: number;
  IdTipoUgDestino: number;
  TipoAviso?: { Id: number; Descricao: string };   
  IdUsuarioLiberacao: number;
  Origem: string;
  Respostas: any[];
  UsuarioUltAlteracao: string;
  Visualizacoes: any[];

  //vem no mural
  DATA_VISUALIZACAO: Date;

  /**
   * Usar o parâmetro opcional para receber um objeto do importador de XML
   * @param obj
   */
  constructor(obj?: any) {
    super();
    if (obj) {
      this.Id = obj.Id;
      this.UsuarioCadastro = obj.UsuarioCadastro;
      this.UsuarioLiberacao = obj.UsuarioLiberacao;
      this.DataCadastro = new Date(obj.DataCadastro);
      this.Titulo = obj.Titulo;
      if (obj.DataValidade) this.DataValidade = new Date(obj.DataValidade);
      if (obj.DataUltAlteracao)
        this.DataUltAlteracao = new Date(obj.DataUltAlteracao);
      this.PermiteResposta = obj.PermiteResposta;
      this.Mensagem = obj.Mensagem;

      this.Arquivos = obj.Arquivos;
      this.Ativo = obj.Ativo;
      this.Destinatarios = obj.Destinatarios;
      if (obj.DtLiberacao) this.DtLiberacao = new Date(obj.DtLiberacao);
      this.IdArquivo = obj.IdArquivo;
      this.IdDepartamento = obj.IdDepartamento;
      if (obj.Departamento)
        this.Departamento = new DepartamentoResumido(obj.Departamento);
      this.IdSistemaOrigem = obj.IdSistemaOrigem;
      this.IdTipoUgDestino = obj.IdTipoUgDestino;
      this.TipoAviso = obj.TipoAviso;    
      this.IdUsuarioLiberacao = obj.IdUsuarioLiberacao;
      this.Origem = obj.Origem;
      this.Protocolo = obj.Protocolo;
      this.Respostas = obj.Respostas;
      this.UsuarioUltAlteracao = obj.UsuarioUltAlteracao;
      this.Visualizacoes = obj.Visualizacoes;
      this.idDestinatario = obj.idDestinatario;

      if (obj.DATA_VISUALIZACAO)
        this.DATA_VISUALIZACAO = new Date(obj.DATA_VISUALIZACAO);
    }
  }
}
